// extracted by mini-css-extract-plugin
export var displayNone = "_r5-6";
export var imgContainer = "_r5-2";
export var overflowHidden = "_r5-3";
export var productInfoCardButtonContainer = "_r5-5";
export var productTitleText = "_r5-4";
export var rightArrow = "_r5-1";
export var rightArrowContainer = "_r5-0";